export const HELP_CENTER_OPEN_EVENT = "r1eventech:open-help-center";

export const openHelpCenter = (path = "/ajuda") => {
  window.dispatchEvent(new CustomEvent(HELP_CENTER_OPEN_EVENT, { detail: { path } }));
};
